export default __webpack_public_path__ + "static/media/Nunito-ExtraLight.554422c3.woff2";